import { StoryHero } from "../components/story/StoryHero";
import { Origin } from "../components/story/Origin";
import { WhyLabb } from "../components/story/WhyLabb";
import { AnatomyOfMark } from "../components/story/AnatomyOfMark";
import { Equation } from "../components/story/Equation";
import { StoryCTA } from "../components/story/StoryCTA";
import { Marquee } from "../components/Marquee";
import { Seo } from "../components/Seo";

export default function Story() {
  return (
    <main data-testid="story-page" className="bg-deepred">
      <Seo
        title="Our Story"
        description="How Chicken Labb redefined fried chicken with absolute discipline in New Jersey. Not luck — method. Precision in the kitchen, art on the plate."
        path="/story"
      />
      <StoryHero />
      <Origin />
      <WhyLabb />
      <AnatomyOfMark />
      <Equation />
      <section className="py-4 sm:py-6">
        <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
          <div className="w-full overflow-hidden rounded-[28px]">
            <Marquee />
          </div>
        </div>
      </section>
      <StoryCTA />
    </main>
  );
}
